// Copyright 2018 Sisense Inc. All rights reserved.

/**
 * @fileoverview Index file for Sisense UI Components abstractions.
 * @author artem.lit@sisense.com (Artem Lytvynov).
 * @copyright Sisense Inc.
 * @licence Sisense License.
 * @module @sbi/core.components
 */

/**
 * Object with ComponentReady and ComponentDestroy Events classes constructors.
 * @type {Object}
 */
exports.events = require('./events');

/**
 * @type {BasicComponent}
 */
exports.BasicComponent = require('./basiccomponent').BasicComponent;
